import { render, staticRenderFns } from "./ProductActionVariantsPropagation.vue?vue&type=template&id=cf5da4ac&"
import script from "./ProductActionVariantsPropagation.vue?vue&type=script&lang=ts&"
export * from "./ProductActionVariantsPropagation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports